import React, { ReactNode } from "react";
import styles from "./FixButton.module.scss";

interface Props {
  children?: ReactNode;
}
const FixButton: React.FC<Props> = (props: Props) => {
  const { children } = props;

  return <div className={styles.positionButton}>{children}</div>;
};

export default FixButton;
